import { Link } from 'react-router-dom';
import { Menu, Search } from 'lucide-react';

import { useSettings } from '@/store/useSettings';
import { themeConfig } from '@/config/theme.config';
import { CartDrawer } from '@/components/cart/CartDrawer';

export function Navbar() {
    const { shopInfo } = useSettings();

    return (
        <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container flex h-16 items-center mx-auto px-4 max-w-[1280px]">
                <div className="mr-4 hidden md:flex">
                    <Link to="/" className="mr-6 flex items-center space-x-2 font-bold text-xl">
                        {shopInfo.logo_url ? (
                            <img src={shopInfo.logo_url} alt={shopInfo.shop_name} className="h-8 w-8 object-contain" />
                        ) : null}
                        <span>{shopInfo.shop_name || themeConfig.defaults.shopName}</span>
                    </Link>
                    <nav className="flex items-center space-x-6 text-sm font-medium">
                        <Link to="/products" className="transition-colors hover:text-foreground/80 text-foreground/60">Products</Link>
                        <Link to="/categories" className="transition-colors hover:text-foreground/80 text-foreground/60">Categories</Link>
                        <Link to="/about" className="transition-colors hover:text-foreground/80 text-foreground/60">About</Link>
                    </nav>
                </div>

                <div className="flex flex-1 items-center justify-between space-x-2 md:justify-end">
                    <div className="w-full flex-1 md:w-auto md:flex-none">
                        {/* Search placeholder */}
                        <div className="relative">
                            <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                            <input
                                placeholder="Search products..."
                                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-8 md:w-[300px] lg:w-[400px]"
                            />
                        </div>
                    </div>
                    <nav className="flex items-center gap-2">
                        <CartDrawer />
                        {/* Mobile Menu Trigger Placeholder */}
                        <button className="md:hidden inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10">
                            <Menu className="h-5 w-5" />
                        </button>
                    </nav>
                </div>
            </div>
        </header>
    );
}
